export const MODAL_INFO_DATA = {
  success: {
    statusText: 'Support Request Received',
    statusMessage: 'Thank you for your support request. You will receive your case number and further information at the email address you provided.',
    buttonLabel: 'Close',
    buttonA11yTitle: '',
    // buttonA11yTitle: 'You are in a layer containing a confirmation that your request has been received. To close this layer, press Enter.',
  },
  error: {
    statusText: 'Something Went Wrong',
    statusMessage: 'Your form was unable to be submitted. Please return to the form and submit it again.',
    buttonLabel: 'Return',
    buttonA11yTitle: '',
  },
};